import React from "react";
import { Col, Row } from "react-bootstrap";
import { AdminApprovalGroup, UserProfile } from "@preveil-api";
import _ from "lodash";

type AllProps = {
  recovery_group: AdminApprovalGroup;
}

// Description: Component to display the recovery group members in the admin panel.
function GroupMembersTableComponent(props: AllProps) {
  const { recovery_group } = props;

  return (
    <div className="table-display">
      <Row className="header-card-row">
        <Col xs={7}>
          <p>Approver</p>
        </Col>
        <Col xs={5}>
          <p>Role</p>
        </Col>
      </Row>
      <div className="table-body">
        {_.map(recovery_group.approvers, (member: UserProfile, index: number) => {
          const { name, address, role} = member;
          return <Row key={index}>
            <Col xs={7}>
              <p className="semi-bold">{name}</p>
              <p>{address.toLowerCase()}</p>
            </Col>
            <Col xs={5}>
              <p className="m-0">{_.capitalize(role)}</p>
            </Col>
          </Row>;
        })}
      </div>
    </div>
  );
}

export default React.memo(GroupMembersTableComponent);